import { EU_DEVICES, US_DEVICES } from 'constants/devices';
import { TECHNOLOGIES_BY_GROUP } from 'constants/products';
import Technology from './Technology';

export const DEVICES = Technology.isRegionVariantUS() ? US_DEVICES : EU_DEVICES;
export const getDeviceFieldLabel = () =>
  Technology.isAvailable(TECHNOLOGIES_BY_GROUP.pancreas)
    ? 'Ultrasound Processor'
    : 'Device';
